import qs from 'qs'

export const queryExhibitionEntryPrevNextBySlug = (options: QueryBySlugPrevNextOptions) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      sort: [`dateStart:${options?.sortDir}`, 'title:asc'],
      pagination: {
        limit: 1
      },
      filters: {
        dateStart: {
          [options?.filter]: options?.filterValue
        }
      },
      fields: [
        ...queryFieldsPrevNext,
        'dateStart'
      ]
    },
    {
      encodeValuesOnly: true
    }
  )
  return `exhibition-entries?${query}`
}
